import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import MakerworldImportButton from './MakerworldImportButton';

const manifest = {
  id: 'makerworld-import',
  nameKey: 'extensions.makerworld_import.name',
  descriptionKey: 'extensions.makerworld_import.description',
  icon: CloudDownloadOutlinedIcon,
  requiredExtensions: [],
  contributions: [
    {
      slotId: 'products.list.actions',
      Component: MakerworldImportButton,
      priority: 20,
    },
  ],
};

export default manifest;
